import {GenericTable} from "@dvrt/graphql-widgets";
import {HasPermission, Link} from "../../widgets";
import DialogButton from "../create/DialogButton";
import {useConcertoGenericQuery} from "../../../hooks";
import {LocationListWithPilotNumberFragment, LocationListWithPilotNumberFragmentDoc} from "../queries.generated";
import {Box} from "@mui/material";
import {defineMessage, defineMessages} from "react-intl";
import {useDomainIDParam} from "@/types";
import {commonTranslations} from "@/utils/translations";
import TableShortcutButton from "@/components/TableShortcutButton";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const LocationList = () => {
    const domainId = useDomainIDParam();

    const query = useConcertoGenericQuery<LocationListWithPilotNumberFragment>(
        "locations",
        LocationListWithPilotNumberFragmentDoc,
        {
            filtering: {
                argumentName: "filter",
                placeHolder: commonTranslations.filterPlaceholders.nameOrDescriptionOrPilotNumber,
                idPrefix: "search-locations",
            },
            fetchPolicy: "cache-and-network",
            extraVariables: {
                domainId,
            },
            initialOrdering: ["name"],
        },
    );

    return (
        <Box sx={{paddingX: 3}}>
            <GenericTable<LocationListWithPilotNumberFragment>
                query={query}
                labels={defineMessages({
                    name: {id: "name", defaultMessage: "Name"},
                    description: {id: "description", defaultMessage: "Description"},
                    pilotNumber: {id: "pilotNumber", defaultMessage: "Pilot number"},
                    canBeDeleted: {id: "unused", defaultMessage: "Unused"}, // Hidden column
                })}
                createButton={
                    <HasPermission name="add_location">
                        <DialogButton domainId={domainId} onSuccess={query.refetch} />
                    </HasPermission>
                }
                dataRenderers={{
                    name: (value, row) => <Link to={`/domains/${domainId}/locations/${row.id}/settings`}>{value}</Link>,
                }}
                hideColumns={["canBeDeleted"]} // Hide canBeDeleted column
                extraColumns={[
                    {
                        path: "actions",
                        label: null,
                        renderer: (row) => {
                            return (
                                <HasPermission name="delete_location">
                                    <TableShortcutButton
                                        shortcutPath={`${row.id}/delete`}
                                        tooltipTitle={commonTranslations.delete}
                                        buttonIcon={faTrash}
                                        color="secondary"
                                        disabled={
                                            !row.canBeDeleted
                                                ? {
                                                      reason: defineMessage({
                                                          id: "delete_location.button_helper_text",
                                                          defaultMessage:
                                                              "Can not reassign the related users to a different location",
                                                      }),
                                                  }
                                                : undefined
                                        }
                                    />
                                </HasPermission>
                            );
                        },
                    },
                ]}
                orderableFields={["name", "description", "pilotNumber"]}
            />
        </Box>
    );
};

export default LocationList;
